<!-- <div class="row mt-2 mr-5">
  <div class="col-lg"></div>
  <div class="col-auto">
      <dx-button class="btn btn-primary" (click)="isNewMessage = true">
        {{ 'ticket-new-message' | translateWithFallback }}
      </dx-button>
  </div>
</div> -->

<div class="card-container dx-card" *ngIf="isNewMessage">
  <dx-form [formGroup]="frmData">
      <div class="form-group">
          <div class="row m-2">
              <div formGroupName="MessageSource">
                  <label class="mb-2" for="MessageSource">{{ 'ticket-message-source' | translateWithFallback }}</label>
                  <div class="col-lg">
                      <label for="SubjectType">{{ 'ticket-subject-type' |translateWithFallback }}</label>
                      <dx-select-box [items]="this.MsgSvc.relationSubject" formControlName="SubjectType">
                      </dx-select-box>
                  </div>
                  <div class="col-lg">

                  </div>
              </div>
          </div>

          <div class="row m-2">
            <label class="mb-2" for="Message">{{ 'ticket-message' | translateWithFallback }}</label>
            <div class="col-sm">
              <div class="form-group">
                <label for="name">{{ 'ticket-title' | translateWithFallback }}</label>
                <input type="text" class="form-control" id="name" [placeholder]="'ticket-title-placeholder' | translateWithFallback" aria-describedby="name"
                  formControlName="Name" name="name" autocompleteOff />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label for="name">{{ 'ticket-machine-name' | translateWithFallback }}</label>
                <input type="text" class="form-control" id="name" [placeholder]="'ticket-machine-name-placeholder' | translateWithFallback" aria-describedby="name"
                  formControlName="SourceId" name="name" autocompleteOff />
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label for="MessageType">{{ 'ticket-message-type' | translateWithFallback }}</label>
                <dx-select-box [items]="this.MsgSvc.messageType" formControlName="MessageType">
                </dx-select-box>
              </div>
            </div>
          </div>

          <div class="row m-2">
            <div class="form-group">
              <label for="MessageContent">{{ 'ticket-message-content' | translateWithFallback }}</label>
              <dx-text-area [height]="90" [maxLength]="250" formControlName="MessageContent">
              </dx-text-area>
            </div>
          </div>
      </div>
  </dx-form>
  <div class="row m-2">
      <div class="col-lg">
          <dx-button class="btn btn-primary" (click)="isNewMessage = false">
            {{ 'ticket-cancel' | translateWithFallback }}
          </dx-button>
      </div>
      <div class="col-auto">
          <dx-button class="btn btn-primary" (click)="save()">
            {{ 'ticket-save' | translateWithFallback }}
          </dx-button>
      </div>
  </div>
</div>

<div app-messages-container [Parent]="'__ROOT__'"></div>
